module.exports = "/packs/images/mission-values/juul-pods@2x-5e63a7b36a38c9ea623928766c594f1f.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/images/mission-values/juul-pods@2x.jpg
// module id = 1780
// module chunks = 0